module.exports = __webpack_public_path__ + "static/media/c_1.862bc592.png";